/*
 * @Desc: 身体数据记录
 * @Author: jiayi zhu
 * @Date: 2020-03-16 10:11:48
 * @LastEditors: simbawu
 */

export default {
  getBodyRecord(data) {
    return this.http('api', 'get', '/meta-interface/v2/weight/list', data);
  },
  addBodyRecord(data) {
    return this.http('api', 'post', '/meta-interface/v2/weight/add', data);
  },
  /**
   * @Desc: 新增便便记录
   * @Author: simbawu
   */
  async postRecordPoos(params) {
    const { data } = await this.http('api', 'post', '/meta-interface/v1/record_kit/create_poo', params);
    return data;
  },
  /**
   * @Desc: 删除便便记录
   * @Author: simbawu
   */
  deleteRecordPoos(id) {
    return this.http('api', 'post', '/meta-interface/v1/record_kit/del_poo', {
      id: Number(id)
    });
  },
  /**
   * @Desc: 更新便便记录
   * @Author: simbawu
   */
  putRecordPoos(data) {
    return this.http('api', 'post', '/meta-interface/v1/record_kit/update_poo', data);
  },
  /**
   * @Desc: 获取单条便便记录详情
   * @Author: simbawu
   */
  async getRecordPoosDetail(id) {
    const { data } = await this.http('api', 'get', '/meta-interface/v1/record_kit/show_poo', { id });
    return data?.data;
  },
  /**
   * @Desc: 获取单条便便记录题目
   * @Author: simbawu
   */
  getRecordPoosQuestions(data) {
    return this.http('api', 'get', '/meta-interface/v1/record_kit/poo_question', data);
  }
};
